import * as Api from '@ViewModels';

/**
 * Mirrors the API's `Account.IsBoardTypeEnabled(DataboardType.Policy)` — `PoliciesEnabled ?? PolicyBoard?.Enabled`,
 * where `policiesEnabled` wins when set. That same check gates whether AMS sync writes
 * `PolicyKeyFactMetadata.PolicyId`, so it decides whether the board-backed renewal filter can resolve at all;
 * accounts without it must get the key-fact selector instead.
 */
export const isPolicyBoardEnabled = (boards?: Api.IBoardFeatures) =>
	boards?.policiesEnabled ?? boards?.policyBoard?.enabled ?? false;

export const DEFAULT_TEXTING_OPT_OUT_MESSAGE =
	'If you\'d prefer not to hear from me by text message, please reply back with "Stop".';
export const TEXTING_OPT_OUT_MESSAGE_MIN_LENGTH = 20;
export const TEXTING_OPT_OUT_MESSAGE_MAX_LENGTH = 320;

export const getTextingOptOutMessage = (texting?: Api.ITextingFeature) =>
	texting?.optOutMessage || DEFAULT_TEXTING_OPT_OUT_MESSAGE;
